import * as React from "react";
import { UitkIcon } from "uitk-react-icons";
import { UitkFlatButton } from "uitk-react-button";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";

export const MyList = () => {
  const ButtonTracked = FlexClickTracker(UitkFlatButton);

  return (
    <ButtonTracked id="my-list-button" rfrr="MyList" moduleName="header" href="/lists" linkName="My List">
      <UitkIcon name="favorite" className="my-list-icon" />
      <span className="is-visually-hidden">My List</span>
    </ButtonTracked>
  );
};
